import type {FetchHotelsImplementationParams} from '@/redux/v1/hotels/list/actions';
import type {Hotel} from '@/redux/v1/hotels/list/models';
import type {AsyncStatus} from '@react-hookz/web';

import {useAsync} from '@react-hookz/web';
import {pick} from 'lodash';
import {useEffect} from 'react';

import {KeywordTypes} from '@/api/keywordApi';
import {FILTER_PARAMS_HOTELS} from '@/modules/common/context/QueryParams/models';
import {useDestination} from '@/modules/common/hooks/useDestination';
import {useFilterParams} from '@/modules/common/hooks/useFilterParams';
import {useSearchParams} from '@/modules/common/hooks/useSearchParams';
import {fromKeywordToGiata} from '@/modules/common/utils/hotelIdFormat';
import {fetchHotelsImplementation} from '@/redux/v1/hotels/list/actions';

export const usePromotedHotel = (): {
  id: string;
  enabled: boolean;
  offer: Hotel | null;
  status: AsyncStatus;
} => {
  const destination = useDestination();
  const isDestinationAHotel = destination.type === KeywordTypes.hotel;

  const [searchParams] = useSearchParams();
  const [filterParams] = useFilterParams();

  const [state, actions] = useAsync(
    (params: FetchHotelsImplementationParams['params']) => {
      return isDestinationAHotel
        ? fetchHotelsImplementation({
            params,
          })
        : // Only request when destination is a hotel
          Promise.resolve(null);
    }
  );

  const offer = state.result?.hotels?.[0] ?? null;

  useEffect(() => {
    actions.execute({
      searchParams,
      filterParams: pick(filterParams, FILTER_PARAMS_HOTELS),
      sortParams: null,
      offset: 0,
      limit: null,
      initial: false,
    });
  }, [actions, searchParams, filterParams]);

  return {
    id: fromKeywordToGiata(destination.id),
    enabled: isDestinationAHotel,
    offer,
    status: state.status,
  };
};
